module.exports = __webpack_public_path__ + "img/durocher_svg_V1.ce09e3de.svg";